import * as ReselectModule from "reselect";
import { IClientCareListState } from ".";
import { IApplicationState } from "..";

export const selectClientCareList: ReselectModule.Selector<
  IApplicationState,
  IClientCareListState
> = (state) => state.clientCareList;
